import React from 'react';

const CardElementAbout = () => {
  return (
    <div className="about-content">
      <h3>Documentation</h3>
      <ul>
        <li>
          <a href="https://stripe.com/docs/payments/card-element" target="_blank" rel="noopener noreferrer">
            Quickstart
          </a>
        </li>
      </ul>
    </div>
  );
};

export default CardElementAbout;
